import React, { useCallback } from "react";
import { Download, X } from "lucide-react";
import ImportRulesButton from "./ImportRulesButton";
import ImportOnlineRulesButton from "./ImportOnlineRulesButton";
import { usePopupLifecycle } from "../../view/popup/usePopupLifecycle";

function ImportRulesModal({ handleClose }) {
    const onClose = useCallback(() => handleClose(), [handleClose]);

    usePopupLifecycle(onClose);

    return (
        <div
            className="oct-shared-popup"
            role="dialog"
            aria-modal="true"
            aria-labelledby="oct-import-rules-title"
            aria-describedby="oct-import-rules-body-copy"
        >
            <div className="oct-shared-popup__backdrop" onClick={onClose} />

            <div
                className="oct-shared-popup__dialog oct-shared-popup__dialog--compact oct-shared-popup__dialog--import-rules"
                onClick={(event) => event.stopPropagation()}
            >
                <div className="oct-shared-popup__header oct-import-rules-popup__header">
                    <div className="oct-shared-popup__title-wrap oct-import-rules-popup__title-wrap">
                        <div className="oct-shared-popup__title-icon">
                            <Download size={18} />
                        </div>
                        <div>
                            <h4 id="oct-import-rules-title" className="oct-shared-popup__title">Import Rules</h4>
                        </div>
                    </div>

                    <button
                        type="button"
                        className="oct-shared-popup__close"
                        onClick={onClose}
                        aria-label="Close import rules popup"
                    >
                        <X size={18} />
                    </button>
                </div>

                <div className="oct-shared-popup__body oct-import-rules-popup__body">
                    <p id="oct-import-rules-body-copy" className="oct-import-rules-popup__intro">
                        Online import fetches the latest configured rules source. Offline import lets you upload an `.xlsx` export directly.
                    </p>

                    <div className="oct-import-rules-popup__actions">
                        <ImportOnlineRulesButton
                            handleClose={onClose}
                            className="modal-v2-btn-primary"
                        />
                        <ImportRulesButton
                            handleClose={onClose}
                            className="modal-v2-btn-outline"
                        />
                    </div>
                </div>

                <div className="oct-shared-popup__footer oct-shared-popup__footer--end">
                    <button type="button" className="btn modal-v2-btn modal-v2-btn-outline" onClick={onClose}>
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
}

export default ImportRulesModal;
